/* Aji Sweets theme — vanilla JS, no dependencies */
(() => {
  'use strict';

  const theme = window.AjiTheme || { routes: {} };
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const isCartPage = () => document.body.classList.contains('template-cart');

  /* ---------------- Toast ---------------- */
  let toastTimer;
  function toast(message) {
    const el = $('#Toast');
    if (!el) return;
    el.textContent = message;
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { el.hidden = true; }, 3000);
  }

  /* ---------------- Drawers ---------------- */
  let lastFocus = null;
  function openDrawer(drawer) {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('has-drawer');
    $$(`[aria-controls="${drawer.id}"]`).forEach((b) => b.setAttribute('aria-expanded', 'true'));
    const focusable = drawer.querySelector('button, a, input');
    if (focusable) setTimeout(() => focusable.focus(), 50);
  }
  function closeDrawer(drawer) {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('has-drawer');
    $$(`[aria-controls="${drawer.id}"]`).forEach((b) => b.setAttribute('aria-expanded', 'false'));
    if (lastFocus) lastFocus.focus();
  }
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); openDrawer(document.getElementById(opener.dataset.drawerOpen)); return; }
    const closer = e.target.closest('[data-drawer-close]');
    if (closer) { closeDrawer(closer.closest('[data-drawer]')); return; }
    const cartToggle = e.target.closest('[data-cart-toggle]');
    if (cartToggle && theme.cartDrawer && !isCartPage()) { e.preventDefault(); openDrawer($('#CartDrawer')); }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    $$('[data-drawer].is-open').forEach(closeDrawer);
    $$('details[open].nav__dropdown, details[open][data-search-toggle], details[open].filters').forEach((d) => d.removeAttribute('open'));
  });

  /* ---------------- Emojis from admin names (collection / menu / product titles) ---------------- */
  if (theme.stripEmojis) {
    const EMOJI = /(?![\u00A9\u00AE\u2122\u2605])\p{Extended_Pictographic}\uFE0F?|\uFE0F|\u200D/gu; // keeps © ® ™ ★
    const clean = (root) => {
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
        acceptNode: (n) => (n.parentElement && n.parentElement.closest('script, style, textarea, [contenteditable]') ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT),
      });
      for (let n = walker.nextNode(); n; n = walker.nextNode()) {
        if (EMOJI.test(n.nodeValue)) { EMOJI.lastIndex = 0; n.nodeValue = n.nodeValue.replace(EMOJI, '').replace(/\s{2,}/g, ' '); }
        EMOJI.lastIndex = 0;
      }
    };
    clean(document.body);
    new MutationObserver((list) => list.forEach((m) => m.addedNodes.forEach((n) => { if (n.nodeType === 1) clean(n); })))
      .observe(document.body, { childList: true, subtree: true });
  }

  /* ---------------- Header ---------------- */
  const header = $('[data-header]');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 8);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    // If the menu doesn't fit on one line, switch to the menu button
    const nav = $('.header__nav', header);
    const list = nav && $('.nav', nav);
    const fit = () => {
      if (!nav || !list) return;
      header.classList.remove('is-compact');
      if (getComputedStyle(nav).display === 'none') return;
      header.classList.toggle('is-compact', list.scrollWidth > nav.clientWidth + 1);
    };
    fit();
    window.addEventListener('resize', fit);
    if (document.fonts) document.fonts.ready.then(fit);
    window.addEventListener('load', fit);
  }

  // Close open <details> dropdowns when clicking elsewhere, and only allow one open at a time.
  document.addEventListener('click', (e) => {
    $$('details[open].nav__dropdown, details[open][data-search-toggle], details[open].filters, details[open][data-store-picker]').forEach((d) => {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
  });
  $$('.nav__dropdown').forEach((d) => {
    d.addEventListener('toggle', () => {
      if (d.open) $$('.nav__dropdown[open]').forEach((o) => { if (o !== d) o.removeAttribute('open'); });
    });
    if (window.matchMedia('(hover: hover)').matches) {
      let t;
      d.addEventListener('mouseenter', () => { clearTimeout(t); d.setAttribute('open', ''); });
      d.addEventListener('mouseleave', () => { t = setTimeout(() => d.removeAttribute('open'), 150); });
    }
  });
  $$('[data-search-toggle]').forEach((d) => {
    d.addEventListener('toggle', () => { if (d.open) { const i = $('input[type="search"]', d); if (i) i.focus(); } });
  });

  /* ---------------- Announcement bar ---------------- */
  $$('[data-announcement]').forEach((bar) => {
    const items = $$('.announcement__item', bar);
    if (items.length < 2) return;
    let i = 0;
    let paused = false;
    bar.addEventListener('mouseenter', () => { paused = true; });
    bar.addEventListener('mouseleave', () => { paused = false; });
    setInterval(() => {
      if (paused) return;
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, parseInt(bar.dataset.interval, 10) || 5000);
  });

  /* ---------------- Cart ---------------- */
  function updateCartCount(count) {
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.classList.toggle('is-empty', count === 0);
      el.classList.add('is-bumped');
      setTimeout(() => el.classList.remove('is-bumped'), 300);
    });
  }

  function renderDrawer(html) {
    if (!html) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = $('#CartDrawerInner', doc);
    const current = $('#CartDrawerInner');
    if (fresh && current) current.replaceWith(fresh);
  }

  async function refreshCount() {
    try {
      const cart = await fetch(theme.routes.cartJs, { headers: { Accept: 'application/json' } }).then((r) => r.json());
      updateCartCount(cart.item_count);
    } catch (_) { /* ignore */ }
  }

  /* ---------------- Fly-to-cart ---------------- */
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function flyToCart(img) {
    const target = $('[data-cart-toggle]');
    if (!img || !target || reducedMotion || !img.animate) return Promise.resolve();
    const a = img.getBoundingClientRect();
    const b = target.getBoundingClientRect();
    if (!a.width) return Promise.resolve();
    const size = Math.min(a.width, a.height, 160);
    const clone = document.createElement('img');
    clone.src = img.currentSrc || img.src;
    clone.className = 'fly-img';
    clone.alt = '';
    Object.assign(clone.style, {
      left: `${a.left + a.width / 2 - size / 2}px`,
      top: `${a.top + a.height / 2 - size / 2}px`,
      width: `${size}px`,
      height: `${size}px`,
    });
    document.body.appendChild(clone);
    const dx = b.left + b.width / 2 - (a.left + a.width / 2);
    const dy = b.top + b.height / 2 - (a.top + a.height / 2);
    return clone.animate(
      [
        { transform: 'translate(0, 0) scale(1) rotate(0deg)' },
        { transform: `translate(${dx * 0.45}px, ${Math.min(dy, 0) - 90}px) scale(.7) rotate(-25deg)`, offset: 0.45 },
        { transform: `translate(${dx}px, ${dy}px) scale(.12) rotate(30deg)`, opacity: 0.7 },
      ],
      { duration: 800, easing: 'cubic-bezier(.45,.05,.55,.95)' }
    ).finished.then(() => clone.remove(), () => clone.remove());
  }

  function findSourceImage(btn) {
    const scope = btn.closest('.card, .upsell__item, [data-product-section]');
    if (scope) return scope.querySelector('.card__img, .upsell__item img, .gallery__img');
    if (btn.closest('[data-candy-hero]')) return $('.candy-orb.is-active img');
    return null;
  }

  async function addToCart(body, button) {
    if (button) button.classList.add('is-loading');
    try {
      body.append('sections', 'cart-drawer');
      body.append('sections_url', window.location.pathname);
      const res = await fetch(theme.routes.cartAdd + '.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body,
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || 'Could not add to cart');
      if (data.sections) renderDrawer(data.sections['cart-drawer']);
      await flyToCart(button && findSourceImage(button));
      await refreshCount();
      if (theme.cartDrawer && !isCartPage()) openDrawer($('#CartDrawer'));
      else if (isCartPage()) window.location.reload();
      else toast('Added to cart');
      return true;
    } catch (err) {
      toast(err.message);
      return false;
    } finally {
      if (button) button.classList.remove('is-loading');
    }
  }

  // Quick add (product cards, cart upsell)
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    const body = new FormData();
    body.append('id', btn.dataset.quickAdd);
    body.append('quantity', '1');
    addToCart(body, btn);
  });

  // Line quantity changes (drawer + cart page)
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-line-change]');
    if (!btn) return;
    e.preventDefault();
    const line = btn.closest('.cart-line');
    if (line) line.classList.add('is-updating');
    try {
      const res = await fetch(theme.routes.cartChange + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          line: parseInt(btn.dataset.lineChange, 10),
          quantity: Math.max(0, parseInt(btn.dataset.quantity, 10)),
          sections: 'cart-drawer',
          sections_url: window.location.pathname,
        }),
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || 'Could not update cart');
      if (isCartPage()) { window.location.reload(); return; }
      if (data.sections) renderDrawer(data.sections['cart-drawer']);
      updateCartCount(data.item_count);
    } catch (err) {
      toast(err.message);
      if (line) line.classList.remove('is-updating');
    }
  });

  // Cart note autosave
  const note = $('[data-cart-note]');
  if (note) {
    let t;
    note.addEventListener('input', () => {
      clearTimeout(t);
      t = setTimeout(() => {
        fetch(theme.routes.cart + '/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ note: note.value }),
        });
      }, 500);
    });
  }

  /* ---------------- Quantity inputs ---------------- */
  document.addEventListener('click', (e) => {
    const minus = e.target.closest('[data-qty-minus]');
    const plus = e.target.closest('[data-qty-plus]');
    if (!minus && !plus) return;
    const input = $('input', (minus || plus).closest('[data-qty]'));
    const v = parseInt(input.value, 10) || 1;
    input.value = Math.max(1, v + (plus ? 1 : -1));
  });

  /* ---------------- Product page ---------------- */
  $$('[data-product-section]').forEach((section) => {
    const jsonEl = $('[data-product-json]', section);
    const product = jsonEl ? JSON.parse(jsonEl.textContent) : null;
    const form = $('[data-product-form]', section);
    const idInput = $('[data-variant-id]', section);
    const picker = $('[data-variant-picker]', section);
    const addButtons = $$('[data-add-button]', section);
    const track = $('[data-gallery-track]', section);
    const slides = track ? $$('.gallery__slide', track) : [];
    const thumbs = $$('[data-thumb-index]', section);
    const dots = $$('.gallery__dot', section);

    // Add to cart
    if (form) {
      form.addEventListener('submit', (e) => {
        e.preventDefault();
        const errorEl = $('[data-form-error]', form);
        if (errorEl) errorEl.hidden = true;
        addToCart(new FormData(form), $('[data-add-button]', form));
      });
    }

    // Gallery
    function goToSlide(index) {
      if (!track || !slides[index]) return;
      track.scrollTo({ left: slides[index].offsetLeft, behavior: 'smooth' });
    }
    thumbs.forEach((t) => t.addEventListener('click', () => goToSlide(parseInt(t.dataset.thumbIndex, 10))));
    if (track && slides.length > 1) {
      let raf;
      track.addEventListener('scroll', () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => {
          const i = Math.round(track.scrollLeft / track.clientWidth);
          thumbs.forEach((t, n) => t.classList.toggle('is-active', n === i));
          dots.forEach((d, n) => d.classList.toggle('is-active', n === i));
        });
      }, { passive: true });
    }

    // Variant picker
    if (picker && product) {
      const selected = () => $$('fieldset', picker).map((fs) => {
        const checked = $('input:checked', fs);
        return checked ? checked.value : null;
      });

      const markAvailability = () => {
        const current = selected();
        $$('input[data-option-position]', picker).forEach((input) => {
          const pos = parseInt(input.dataset.optionPosition, 10) - 1;
          const test = current.slice();
          test[pos] = input.value;
          const match = product.variants.find((v) => v.options.every((o, i) => o === test[i]));
          const label = input.nextElementSibling;
          if (label) label.classList.toggle('is-unavailable', !match || !match.available);
        });
      };
      markAvailability();

      picker.addEventListener('change', async (e) => {
        const fs = e.target.closest('fieldset');
        if (fs) { const out = $('[data-option-value]', fs); if (out) out.textContent = e.target.value; }
        const opts = selected();
        const variant = product.variants.find((v) => v.options.every((o, i) => o === opts[i]));
        markAvailability();

        addButtons.forEach((b) => {
          const label = $('[data-add-label]', b);
          b.disabled = !variant || !variant.available;
          if (label) label.textContent = !variant ? 'Unavailable' : variant.available ? 'Add to cart' : 'Sold out';
        });
        if (!variant) return;

        if (idInput) idInput.value = variant.id;
        const url = `${product.url}?variant=${variant.id}`;
        window.history.replaceState({}, '', url);

        if (variant.featured_media_id) {
          const idx = slides.findIndex((s) => s.dataset.mediaId === String(variant.featured_media_id));
          if (idx > -1) goToSlide(idx);
        }

        // Re-render the price with the store's own money format
        try {
          const html = await fetch(`${url}&section_id=${section.dataset.sectionId}`).then((r) => r.text());
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const freshPrice = $('[data-product-price]', doc);
          const curPrice = $('[data-product-price]', section);
          if (freshPrice && curPrice) curPrice.innerHTML = freshPrice.innerHTML;
          const freshSticky = $('[data-sticky-price]', doc);
          const curSticky = $('[data-sticky-price]', section);
          if (freshSticky && curSticky) curSticky.innerHTML = freshSticky.innerHTML;
        } catch (_) { /* keep old price on network error */ }
      });
    }

    // Sticky add-to-cart bar (mobile)
    const sticky = $('[data-sticky-atc]', section);
    const mainButton = form ? $('[data-add-button]', form) : null;
    if (sticky && mainButton && 'IntersectionObserver' in window) {
      new IntersectionObserver(([entry]) => {
        const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', String(!show));
        const btn = $('button', sticky);
        if (btn) btn.tabIndex = show ? 0 : -1;
      }).observe(mainButton);
    }
  });

  /* ---------------- Product recommendations ---------------- */
  $$('[data-recommendations]').forEach(async (el) => {
    if (el.children.length) return;
    try {
      const html = await fetch(el.dataset.url).then((r) => r.text());
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = $('[data-recommendations]', doc);
      if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
    } catch (_) { /* ignore */ }
  });

  /* ---------------- Stores: switch photo + details ---------------- */
  $$('[data-stores]').forEach((section) => {
    const tabs = $$('[data-store-tab]', section);
    const photos = $$('[data-store-photo]', section);
    const cards = $$('[data-store-card]', section);
    const select = (index) => {
      tabs.forEach((t, i) => {
        t.classList.toggle('is-active', i === index);
        t.setAttribute('aria-selected', i === index ? 'true' : 'false');
      });
      photos.forEach((p, i) => p.classList.toggle('is-active', i === index));
      cards.forEach((c, i) => {
        c.classList.toggle('is-active', i === index);
        c.hidden = i !== index;
      });
    };
    const hoverable = window.matchMedia('(hover: hover) and (min-width: 990px)').matches;
    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => {
        select(i);
        // keep the chosen pill in view on phones
        tab.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
      });
      if (hoverable) tab.addEventListener('mouseenter', () => select(i));
      tab.addEventListener('keydown', (e) => {
        if (!['ArrowDown', 'ArrowUp', 'ArrowRight', 'ArrowLeft'].includes(e.key)) return;
        e.preventDefault();
        const next = (i + (e.key === 'ArrowDown' || e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
        tabs[next].focus();
        select(next);
      });
    });
    // Theme editor: show the store whose block is selected
    section.addEventListener('shopify:block:select', (e) => {
      const i = tabs.findIndex((t) => t.dataset.blockId === e.detail.blockId);
      if (i > -1) select(i);
    });
  });

  /* ---------------- My store (header picker, stores band, product page) ---------------- */
  const STORE_KEY = 'aji-my-store';
  const storesEl = $('#StoresData');
  let stores = [];
  try { stores = storesEl ? JSON.parse(storesEl.textContent) : []; } catch (_) { stores = []; }
  const getStoreId = () => { try { return localStorage.getItem(STORE_KEY); } catch (_) { return null; } };

  function applyStore() {
    const store = stores.find((s) => s.id === getStoreId()) || null;
    $$('[data-my-store-name]').forEach((el) => { el.textContent = store ? store.name : el.dataset.empty; });
    $$('[data-set-store]').forEach((btn) => {
      const mine = store && btn.dataset.setStore === store.id;
      btn.classList.toggle('is-mine', Boolean(mine));
      btn.setAttribute('aria-pressed', mine ? 'true' : 'false');
      const label = $('[data-mine-label]', btn);
      if (label) label.textContent = mine ? btn.dataset.labelOn || 'Your store' : btn.dataset.labelOff || 'Make this my store';
    });
    const line = $('[data-my-store-line]');
    if (line) {
      const text = $('[data-my-store-text]', line);
      if (store) {
        const where = `${store.name}${store.location ? `, ${store.location}` : ''}`;
        const visit = ($('[data-store-picker]') || {}).dataset?.visitText || 'Taste it first at';
        text.innerHTML = `${visit} <a href="${store.map}" target="_blank" rel="noopener">${where}</a>${store.hours ? ` · ${store.hours}` : ''}`;
      }
      line.hidden = !store;
    }
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-set-store]');
    if (!btn) return;
    const id = btn.dataset.setStore;
    try {
      if (getStoreId() === id && btn.closest('[data-stores-band]')) localStorage.removeItem(STORE_KEY);
      else localStorage.setItem(STORE_KEY, id);
    } catch (_) { /* storage blocked: nothing to remember */ }
    applyStore();
    const picker = btn.closest('[data-store-picker]');
    if (picker) picker.removeAttribute('open');
    const store = stores.find((s) => s.id === getStoreId());
    const msgs = ($('[data-store-picker]') || {}).dataset || {};
    toast(store ? `${store.name} ${msgs.toastSet || 'is now your store'}` : msgs.toastClear || 'Store cleared');
  });
  applyStore();

  /* ---------------- Stores band: drag with the mouse, arrows ---------------- */
  $$('[data-stores-band]').forEach((band) => {
    const track = $('[data-band-track]', band);
    if (!track) return;

    let down = false; let moved = false; let startX = 0; let startLeft = 0;
    track.addEventListener('pointerdown', (e) => {
      if (e.pointerType !== 'mouse' || e.button !== 0 || e.target.closest('a, button')) return;
      down = true; moved = false; startX = e.clientX; startLeft = track.scrollLeft;
    });
    window.addEventListener('pointermove', (e) => {
      if (!down) return;
      const dx = e.clientX - startX;
      if (!moved && Math.abs(dx) < 5) return;
      moved = true;
      track.classList.add('is-dragging');
      track.scrollLeft = startLeft - dx;
    });
    window.addEventListener('pointerup', () => {
      if (!down) return;
      down = false;
      if (!moved) return;
      // let the browser snap to the nearest store
      const left = track.scrollLeft;
      track.classList.remove('is-dragging');
      track.scrollLeft = left;
      track.scrollBy({ left: 0, behavior: 'smooth' });
    });
  });

  /* ---------------- Scroll rows: arrows step one item, and dim at either end ---------------- */
  // Our own glide instead of the browser's smooth scroll, which some browsers cancel on snapping rows.
  function glide(track, target) {
    const start = track.scrollLeft;
    const max = track.scrollWidth - track.clientWidth;
    target = Math.max(0, Math.min(max, target));
    if (Math.abs(target - start) < 1) return;
    track.classList.add('is-gliding');
    const finish = () => {
      track.scrollLeft = target;
      track.classList.remove('is-gliding');
      track.dispatchEvent(new Event('scroll'));
    };
    if (reducedMotion) { finish(); return; }
    const duration = 420;
    const t0 = performance.now();
    let done = false;
    const fallback = setTimeout(() => { if (!done) { done = true; finish(); } }, duration + 250);
    const frame = (now) => {
      if (done) return;
      const p = Math.min(1, (now - t0) / duration);
      const eased = 1 - Math.pow(1 - p, 3);
      track.scrollLeft = start + (target - start) * eased;
      if (p < 1) requestAnimationFrame(frame);
      else { done = true; clearTimeout(fallback); finish(); }
    };
    requestAnimationFrame(frame);
  }

  function initScrollRow(row) {
    if (row.dataset.rowReady) return;
    row.dataset.rowReady = '1';
    const track = $('[data-row-track]', row);
    const prev = $('[data-row-prev]', row);
    const next = $('[data-row-next]', row);
    if (!track || !prev || !next) return;
    // where each item sits when snapped to the row's start edge
    const stops = () => {
      const edge = parseFloat(getComputedStyle(track).scrollPaddingLeft) || 0;
      const base = track.getBoundingClientRect().left;
      return Array.from(track.children).map((el) => track.scrollLeft + el.getBoundingClientRect().left - base - edge);
    };
    const update = () => {
      const max = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max;
    };
    next.addEventListener('click', () => {
      const x = track.scrollLeft;
      const to = stops().find((s) => s > x + 4);
      glide(track, to === undefined ? track.scrollWidth : to);
    });
    prev.addEventListener('click', () => {
      const x = track.scrollLeft;
      const to = stops().reverse().find((s) => s < x - 4);
      glide(track, to === undefined ? 0 : to);
    });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    window.addEventListener('load', update);
    update();
  }
  $$('[data-scroll-row]').forEach(initScrollRow);
  // Theme editor: sections are re-rendered after edits, so wire their arrows again
  document.addEventListener('shopify:section:load', (e) => $$('[data-scroll-row]', e.target).forEach(initScrollRow));

  /* ---------------- Address forms: preselect the saved country ---------------- */
  $$('select[data-default]').forEach((select) => {
    const value = select.dataset.default;
    if (value && [...select.options].some((o) => o.value === value)) select.value = value;
  });

  /* ---------------- Collection filters ---------------- */
  $$('[data-auto-submit]').forEach((el) => {
    el.addEventListener('change', () => el.form && el.form.submit());
  });
})();
